import { LanguageISO6391 } from 'ai-constants'
import { getCurrentLanguage } from './active-language'
import { initializeI11n } from './i18n'

export { getCurrentLanguage } from './active-language'

export const intlLocaleByLanguage = {
  es: 'es-AR',
  en: 'en-US',
} satisfies Record<LanguageISO6391, string>

export type Translate = (
  word: string,
  variables?: Record<string, unknown>,
  fallback?: string,
) => string

export const buildTranslate = (
  lang: LanguageISO6391,
  instance = initializeI11n(),
): Translate => {
  const fixedTranslate = instance.getFixedT(lang, 'common')

  return (word, variables, fallback) => {
    const translation = fixedTranslate(word, {
      ...variables,
      defaultValue: fallback || word,
    })

    return typeof translation === 'string' ? translation : fallback || word
  }
}

export const t = (
  word: string,
  variables?: Record<string, unknown>,
  lang: LanguageISO6391 = getCurrentLanguage(),
): string => buildTranslate(lang)(word, variables)
